// The public purchase steps, in order. Used for the HubSpot page titles and checkout step events.
export const CHECKOUT_STEPS = [
  { route: "/step1", key: "step1", label: "Step 1: Choose Your Package" },
  { route: "/step2", key: "step2", label: "Step 2: Find Your Account" },
  { route: "/step3", key: "step3", label: "Step 3: Personal Information" },
  { route: "/step4", key: "step4", label: "Step 4: Address" },
  { route: "/step5", key: "step5", label: "Step 5: Additional Options" },
  { route: "/step6", key: "step6", label: "Step 6: Checkout" },
  { route: "/confirm", key: "confirm", label: "Order Complete" },
] as const;

export const checkoutStepForRoute = (route: string) => CHECKOUT_STEPS.find((s) => s.route === route);
